const LOCAL_CONFIG = {
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://x5x7ac5kf1.execute-api.us-west-2.amazonaws.com/alpha"
  },
  // CPCP V2: All stages point to beta. Both CPCP V2
  // alpha and beta use ApaqPortal beta as their backend,
  // and the Cognito auth is from the beta account.
  cpcpV2ApiGateway: {
    REGION: "us-west-2",
    URL: "https://wnn5bcidt0.execute-api.us-west-2.amazonaws.com/beta"
  },
  // ApaqPortalService: Coral Fargate service for shipment operations
  apaqPortalServiceGateway: {
    REGION: "us-west-2",
    URL: "https://5licsjm35a.execute-api.us-west-2.amazonaws.com"
  },
  cognito: {
    APP_CLIENT_ID: "5imilnp1a28aqm218fvr76bkn4",
    IDENTITY_POOL_ID: "us-west-2:de9e5784-d6d3-4f98-8e58-51ba74fe1dee",
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_ImF2e3jM8"
  },
  oauth: {
    domain: "us-west-2imf2e3jm8.auth.us-west-2.amazoncognito.com",
    scope: ['openid'],
    redirectSignIn: "http://localhost:3000",
    redirectSignOut: "http://localhost:3000",
    responseType: 'code'
  }
};

const ALPHA_CONFIG = {
  apiGateway: {
    REGION: "us-west-2",
    URL: "https://x5x7ac5kf1.execute-api.us-west-2.amazonaws.com/alpha"
  },
  cpcpV2ApiGateway: {
    REGION: "us-west-2",
    URL: "https://wnn5bcidt0.execute-api.us-west-2.amazonaws.com/beta"
  },
  apaqPortalServiceGateway: {
    REGION: "us-west-2",
    URL: "https://5licsjm35a.execute-api.us-west-2.amazonaws.com"
  },
  cognito: {
    APP_CLIENT_ID: "5imilnp1a28aqm218fvr76bkn4",
    IDENTITY_POOL_ID: "us-west-2:de9e5784-d6d3-4f98-8e58-51ba74fe1dee",
    REGION: "us-west-2",
    USER_POOL_ID: "us-west-2_ImF2e3jM8"
  },
  oauth: {
    domain: "us-west-2imf2e3jm8.auth.us-west-2.amazoncognito.com",
    scope: ['openid'],
    redirectSignIn: "https://portal.alpha.apaq.wolfgang.a2z.com",
    redirectSignOut: "https://portal.alpha.apaq.wolfgang.a2z.com",
    responseType: 'code'
  }
};

const BETA_CONFIG = {
  apiGateway: {
      REGION: "us-west-2",
      URL: "https://jozmdwcfe5.execute-api.us-west-2.amazonaws.com/beta"
  },
  cpcpV2ApiGateway: {
      REGION: "us-west-2",
      URL: "https://wnn5bcidt0.execute-api.us-west-2.amazonaws.com/beta"
  },
  // ApaqPortalService: Coral Fargate service
  apaqPortalServiceGateway: {
      REGION: "us-west-2",
      URL: "https://4f5w6buxll.execute-api.us-west-2.amazonaws.com"
  },
  cognito: {
      APP_CLIENT_ID: "8j3b1t1iko3a1mpmc5uf718js",
      IDENTITY_POOL_ID: "us-west-2:23d3423e-4113-4cb1-ba45-5e642a5dcd18",
      REGION: "us-west-2",
      USER_POOL_ID: "us-west-2_NjgMfQjDm"
  },
  oauth: {
    domain: "apaq-portal-beta.auth.us-west-2.amazoncognito.com",
    scope: ['openid'],
    redirectSignIn: "https://portal.beta.apaq.wolfgang.a2z.com",
    redirectSignOut: "https://portal.beta.apaq.wolfgang.a2z.com",
    responseType: 'code'
  }
};

const configuration: { [key: string]: any } = new Map<string, any>([
    ["localhost", LOCAL_CONFIG],
    ["localhost.a2z.com", ALPHA_CONFIG],
    ["portal.alpha.apaq.wolfgang.a2z.com", ALPHA_CONFIG],
    ["portal.beta.apaq.wolfgang.a2z.com", BETA_CONFIG]
]);

const ENDPOINT_CONFIGS: { [key: string]: any } = {
    "alpha": ALPHA_CONFIG,
    "beta": BETA_CONFIG,
    "local": LOCAL_CONFIG,
};

const LOCAL_OAUTH_REDIRECTS = {
    redirectSignIn: "http://localhost:3000",
    redirectSignOut: "http://localhost:3000",
};

function buildLocalDevConfig(envConfig: any) {
    return {
        apiGateway: envConfig.apiGateway,
        cpcpV2ApiGateway: envConfig.cpcpV2ApiGateway,
        apaqPortalServiceGateway: envConfig.apaqPortalServiceGateway,
        cognito: envConfig.cognito,
        oauth: {
            ...envConfig.oauth,
            ...LOCAL_OAUTH_REDIRECTS,
        },
    };
}

function resolveConfig() {
    const endpoint = process.env.REACT_APP_API_ENDPOINT;
    const isLocalDev = window.location.hostname === 'localhost';
    if (!endpoint || !isLocalDev) {
        return configuration.get(window.location.hostname);
    }
    if (ENDPOINT_CONFIGS[endpoint]) {
        return buildLocalDevConfig(ENDPOINT_CONFIGS[endpoint]);
    }
    // Custom URL provided — use LOCAL_CONFIG as base with overridden API endpoint
    return buildLocalDevConfig({
        ...LOCAL_CONFIG,
        apiGateway: {
            ...LOCAL_CONFIG.apiGateway,
            URL: endpoint,
        },
    });
}

export const CONFIG = resolveConfig();